<template>
  <div class="loginBG" :style="'height:' + this.$store.state.maxH + 'px'">
    <div class="loginBox">
      <login_c />
    </div>
  </div>
</template>

<script>
import login_c from "./login/login";

export default {
  name: "login",
  components: {
    login_c,
  },

  mounted() {
  },

  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.loginBG {
  width: 100%;
  height: 100%;
  background: url('../../assets/login_images/bg.png');
  background-size: 100% 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
  position: relative;

  .loginBox {
    position: absolute;
    top: calc((100% - 488px) / 2);
    left: 61%;
    width: 482px;
    height: 488px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 1px rgba(0, 0, 53, 0.18);
    border-radius: 10px;
  }
}
</style>
